<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19 11H17C15.8954 11 15 11.8954 15 13V15C15 16.1046 15.8954 17 17 17H19M19 11V17M19 11V9.5C19 5.91015 16.0899 3 12.5 3H11.5C7.91015 3 5 5.91015 5 9.5V11M19 17L18.4558 18.6325C18.1836 19.4491 17.4193 20 16.5585 20H13M5 11H7C8.10457 11 9 11.8954 9 13V15C9 16.1046 8.10457 17 7 17H5V11Z"
      stroke="#606367"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
